'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The alphabet.
 */
var SelectAlphabet = function SelectAlphabet(_ref) {
    var alphabet = _ref.alphabet,
        _onClick = _ref.onClick;
    return _react2.default.createElement(
        'ul',
        { className: 'sb-selectAlphabet' },
        ((0, _lodash.isString)(alphabet) ? alphabet.split('') : alphabet).map(function (character, index) {
            return _react2.default.createElement(
                'li',
                {
                    key: index,
                    onClick: function onClick() {
                        return _onClick(character);
                    },
                    className: 'sb-selectAlphabet__character'
                },
                character
            );
        })
    );
};

SelectAlphabet.propTypes = {
    /**
     * You can provide string with all alphabet characters or an array of characters to be displayed.
     * It is English alphabet by default.
     */
    alphabet: _react.PropTypes.oneOfType([_react.PropTypes.array, _react.PropTypes.string]),
    /**
     * The 'click' event handler.
     * It will receive a character as an argument.
     */
    onClick: _react.PropTypes.func.isRequired
};

SelectAlphabet.defaultProps = {
    alphabet: 'abcdefghijklmnopqrstuvwxyz'
};

exports.default = SelectAlphabet;


//////////////////
// WEBPACK FOOTER
// ./~/rp-react-select/lib/js/components/SelectAlphabet.js
// module id = 2770
// module chunks = 0